import * as yup from 'yup';

export const cancellationReasonSchema = yup.object().shape({
  cancellationReason: yup
    .string()
    .required('Motivo é obrigatório')
    .trim()
    .test('not-only-numbers', 'Motivo não pode conter apenas números', (value) => {
      return !!value && !/^\d+$/.test(value.trim());
    }),
});
